import React, { useState } from 'react';
import { Check, Loader2, Send } from 'lucide-react';
import { submitLead } from '../api';
import { useMonetization } from '../context/MonetizationContext';

// A UAE lead-gen inquiry form. `type` tags the lead (business/school/insurance/property).
const LeadForm = ({ type, title, blurb, cta = 'Request info', icon: Icon, accent = '#2F663C' }) => {
  const { leadgenEnabled } = useMonetization();
  const [form, setForm] = useState({ name: '', email: '', phone: '', message: '' });
  const [status, setStatus] = useState('idle');
  const [msg, setMsg] = useState('');

  if (!leadgenEnabled) return null;

  const set = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (status === 'loading') return;
    setStatus('loading');
    try {
      const res = await submitLead({ type, ...form });
      setStatus('done');
      setMsg(res.message || "Thanks — we'll be in touch shortly.");
      setForm({ name: '', email: '', phone: '', message: '' });
    } catch (err) {
      setStatus('error');
      setMsg('Please check your details and try again.');
    }
  };

  return (
    <div className="rounded-2xl bg-white border border-[#E6D7A2] overflow-hidden shadow-[0_18px_40px_-28px_rgba(27,29,33,0.45)]">
      <div className="h-[5px] w-full card-rainbow-top" />
      <div className="p-7">
        <div className="flex items-center gap-3">
          {Icon && (
            <span className="flex items-center justify-center w-11 h-11 rounded-xl text-white shrink-0" style={{ background: accent }}>
              <Icon className="w-5 h-5" />
            </span>
          )}
          <div>
            <h3 className="font-display text-[22px] font-semibold text-[#1B1D21] leading-tight">{title}</h3>
            <span className="text-[12px] font-semibold tracking-[0.14em] uppercase text-[#92722A]">Free, no obligation</span>
          </div>
        </div>
        {blurb && <p className="mt-3 text-[15px] leading-relaxed text-[#4B4F58]">{blurb}</p>}

        {status === 'done' ? (
          <div className="mt-5 flex items-center gap-2 text-[15px] font-medium text-[#2F663C]">
            <Check className="w-5 h-5" /> {msg}
          </div>
        ) : (
          <form onSubmit={submit} className="mt-5 grid sm:grid-cols-2 gap-3">
            <input required value={form.name} onChange={(e) => set('name', e.target.value)} placeholder="Your name"
              className="rounded-xl bg-[#EFE7D2] border border-[#E6D7A2] px-4 py-2.5 text-[15px] text-[#1B1D21] outline-none focus:ring-2 focus:ring-[#e0564e]" />
            <input required type="email" value={form.email} onChange={(e) => set('email', e.target.value)} placeholder="Email"
              className="rounded-xl bg-[#EFE7D2] border border-[#E6D7A2] px-4 py-2.5 text-[15px] text-[#1B1D21] outline-none focus:ring-2 focus:ring-[#e0564e]" />
            <input value={form.phone} onChange={(e) => set('phone', e.target.value)} placeholder="Phone (optional)"
              className="sm:col-span-2 rounded-xl bg-[#EFE7D2] border border-[#E6D7A2] px-4 py-2.5 text-[15px] text-[#1B1D21] outline-none focus:ring-2 focus:ring-[#e0564e]" />
            <textarea value={form.message} onChange={(e) => set('message', e.target.value)} rows={2} placeholder="What are you looking for?"
              className="sm:col-span-2 rounded-xl bg-[#EFE7D2] border border-[#E6D7A2] px-4 py-2.5 text-[15px] text-[#1B1D21] outline-none focus:ring-2 focus:ring-[#e0564e] resize-none" />
            {status === 'error' && <p className="sm:col-span-2 text-[13px] text-[#d6453c]">{msg}</p>}
            <div className="sm:col-span-2">
              <button type="submit" disabled={status === 'loading'} className="btn-sunset inline-flex items-center gap-2 rounded-full px-6 py-3 text-[15px] font-semibold disabled:opacity-70">
                {status === 'loading' ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} {cta}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default LeadForm;
